export enum Gender {
	MALE = 'male',
	FEMALE = 'female',
	COMMON = 'common',
}

export interface IPedParentsValue {
	momIndex: number;
	dadIndex: number;
	faceBlend: number; // -1.0 - 1.0
	skinBlend: number; // -1.0 - 1.0
}

export enum PedFaceMorphSection {
	Nose = 'nose',
	Brow = 'brow',
	Cheekbone = 'cheeckbone',
	Cheeks = 'cheeks',
	Eyes = 'eyes',
	Lips = 'lips',
	Jaw = 'jaw',
	Chin = 'chin',
	Neck = 'neck',
}

export interface IPedFaceMorphValue {
	index: number;
	value: number;
}

export enum PedOverlaySection {
	Blemishes = 'blemishes',
	FacialHair = 'facial_hair',
	Eyebrows = 'eyebrows',
	Ageing = 'ageing',
	Makeup = 'makeup',
	Blush = 'blush',
	Complexion = 'complexion',
	SunDamage = 'sun_damage',
	Lipstick = 'lipstick',
	MolesFreckles = 'moles_freckles',
	BodyHair = 'body_hair',
	/** Эти пункты отсутствуют в setHeadOverlay */
	Hair = 'hair',
	Eyes = 'eyes',
	/** Не используется */
	BodyBlemishes = 'body_blemishes',
	AddBodyBlemishes = 'add_body_blemishes',
}

export interface IPedAppearanceValueRules {
	enabled?: boolean;
	charCreation?: boolean;
}

export interface IPedOverlayValue {
	section: PedOverlaySection;
	index: number;
	colorPrimary?: number;
	colorSecondary?: number;
	colorOpacity?: number;
}

export interface IPedAppearanceValue {
	gender: Gender;
	parents: IPedParentsValue;
	faceMorphs: IPedFaceMorphValue[]; // 20
	overlays: IPedOverlayValue[]; // 13
}

export enum PedHeadPosition {
	Initial = 'initial',
	Left = 'left',
	Right = 'right',
}
